/* WOVYRA — free-shipping progress, sticky add-to-cart, size guide opener. */
(function () {
  'use strict';
  var root = document.documentElement;
  var THRESHOLD = parseInt(root.getAttribute('data-wov2-free-ship') || '3000', 10);
  var currency = root.getAttribute('data-wov2-currency') || 'USD';
  var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  var canSubscribe = typeof subscribe === 'function' && events;

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Free shipping progress (cart drawer + cart page) ---------- */
  function barHTML(total) {
    var left = Math.max(THRESHOLD - total, 0);
    var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
    var msg = left > 0
      ? 'You are <strong>' + money(left) + '</strong> away from <strong>free shipping</strong>.'
      : '<strong>Free shipping unlocked.</strong> Nice pick.';
    return '<div class="wov2-ship' + (left > 0 ? '' : ' is-done') + '" role="status">' + msg +
      '<div class="wov2-ship__bar" aria-hidden="true"><span class="wov2-ship__fill" style="width:' + pct + '%"></span></div></div>';
  }

  function place(cart) {
    if (!cart) return;
    var total = cart.total_price || 0;
    var spots = [];
    var drawerHead = document.querySelector('cart-drawer .drawer__header');
    if (drawerHead && cart.item_count > 0) spots.push({ el: drawerHead, where: 'afterend', key: 'drawer' });
    var pageTitle = document.querySelector('cart-items .title-wrapper-with-link');
    if (pageTitle && cart.item_count > 0) spots.push({ el: pageTitle, where: 'afterend', key: 'page' });
    document.querySelectorAll('[data-wov2-ship]').forEach(function (n) {
      var key = n.getAttribute('data-wov2-ship');
      if (!spots.some(function (s) { return s.key === key; })) n.remove();
    });
    spots.forEach(function (s) {
      var existing = document.querySelector('[data-wov2-ship="' + s.key + '"]');
      var wrap = document.createElement('div');
      wrap.setAttribute('data-wov2-ship', s.key);
      wrap.innerHTML = barHTML(total);
      if (existing) existing.replaceWith(wrap);
      else s.el.insertAdjacentElement(s.where, wrap);
    });
  }

  var fetching = null;
  function refresh() {
    if (fetching) return fetching;
    fetching = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(place)
      .catch(function () {})
      .finally(function () { fetching = null; });
    return fetching;
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 180);
  }

  if (canSubscribe) {
    try { subscribe(events.cartUpdate, schedule); } catch (e) {}
  }
  document.addEventListener('cart:updated', schedule);

  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (!drawer.querySelector('[data-wov2-ship]')) schedule();
    }).observe(drawer, { childList: true, subtree: true });
  }
  var cartItems = document.querySelector('cart-items');
  if (cartItems && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (!document.querySelector('[data-wov2-ship="page"]')) schedule();
    }).observe(cartItems, { childList: true, subtree: true });
  }
  refresh();

  /* ---------- Size guide link opens the size chart ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-wov3-size-guide]');
    if (!trigger) return;
    var scope = trigger.closest('product-info') || document;
    var chart = scope.querySelector('[data-wov3-size-chart]');
    if (!chart) {
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'pages/size-guide';
      return;
    }
    chart.open = true;
    chart.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var summary = chart.querySelector('summary');
    if (summary) summary.focus({ preventScroll: true });
  });

  /* ---------- Sticky add-to-cart ---------- */
  var main = document.querySelector('product-info[id^="MainProduct"]');
  var sticky = main && main.querySelector('[data-wov2-sticky]');
  if (!sticky) return;
  var realBtn = main.querySelector('product-form button[name="add"]');
  if (!realBtn) { sticky.remove(); return; }

  /* The product column animates with a transform, which would trap a fixed child. */
  document.body.appendChild(sticky);

  var btn = sticky.querySelector('.wov2-sticky__btn');
  var summary = sticky.querySelector('[data-wov2-sticky-summary]');
  var thumb = sticky.querySelector('.wov2-sticky__img img');
  var change = sticky.querySelector('[data-wov2-sticky-change]');
  var labelDefault = btn.textContent;

  function selectedSummary() {
    var parts = [];
    main.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (i) { parts.push(i.value); });
    main.querySelectorAll('variant-selects select').forEach(function (s) { parts.push(s.value); });
    var price = main.querySelector('.price-item--sale, .price-item--regular');
    var p = price ? price.textContent.trim() : '';
    return [p].concat(parts).filter(Boolean).join(' · ');
  }

  function sync() {
    if (summary) summary.textContent = selectedSummary();
    var disabled = realBtn.hasAttribute('disabled');
    btn.disabled = disabled;
    btn.textContent = disabled ? (realBtn.textContent.trim() || 'Sold out') : labelDefault;
  }

  btn.addEventListener('click', function () {
    if (realBtn.hasAttribute('disabled')) return;
    realBtn.click();
  });

  if (change) {
    change.addEventListener('click', function () {
      var picker = main.querySelector('variant-selects');
      if (!picker) return;
      picker.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var first = picker.querySelector('input:checked');
      if (first) first.focus({ preventScroll: true });
    });
  }

  if (canSubscribe) {
    try {
      subscribe(events.variantChange, function (event) {
        var data = event && event.data;
        if (!data || data.sectionId !== main.dataset.section) return;
        var image = data.variant && data.variant.featured_image;
        if (thumb && image && image.src) {
          thumb.removeAttribute('srcset');
          thumb.src = image.src + (image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        }
        setTimeout(sync, 0);
      });
    } catch (e) {}
  }
  main.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 300);
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (past) sync();
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        root.classList.toggle('wov2-sticky-on', past);
      });
    }, { threshold: 0 }).observe(realBtn);
  }
  sync();
})();
